import apiEndPoints from "../../../../json/apiEndPoints.json";

const GetAuthUser = async (props) => { 
    const _res = await props._api({
        ...props,
        method: apiEndPoints.britex.Admin.post.auth.method,
        endpoint: apiEndPoints.britex.Admin.post.auth.endPoint,
        data: props._encrypt(JSON.stringify(props.data)),
        param: "",
    });

    return _res;
}

export default GetAuthUser;